import { CURRENT_SAVED_FILTER_ID } from '@/app-constants/common.contants';

export const clearSavedFilterCache = (): void => {
  sessionStorage.removeItem(CURRENT_SAVED_FILTER_ID);
};
